export { PLPHeroImage, type PLPHeroImageProps } from './PLPHeroImage';
export { default } from './PLPHeroImage';
